/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface OrderLabel
 */
export interface OrderLabel {
    /**
     * 
     * @type {string}
     * @memberof OrderLabel
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderLabel
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OrderLabel
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderLabel
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrderLabel
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof OrderLabel
     */
    organization?: Organization;
    /**
     * 
     * @type {Array<Order>}
     * @memberof OrderLabel
     */
    orders?: Array<Order> | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLabel
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLabel
     */
    text?: string | null;
}

/**
 * Check if a given object implements the OrderLabel interface.
 */
export function instanceOfOrderLabel(value: object): value is OrderLabel {
    return true;
}

export function OrderLabelFromJSON(json: any): OrderLabel {
    return OrderLabelFromJSONTyped(json, false);
}

export function OrderLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderLabel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderFromJSON)),
        'color': json['color'] == null ? undefined : json['color'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function OrderLabelToJSON(json: any): OrderLabel {
    return OrderLabelToJSONTyped(json, false);
}

export function OrderLabelToJSONTyped(value?: OrderLabel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderToJSON)),
        'color': value['color'],
        'text': value['text'],
    };
}

